import { cn } from "@/lib/utils";

const VARIANTS = {
  default: "bg-slate-100 text-slate-700 border-slate-200",
  aqua: "bg-brand-aqua-light text-brand-aqua-hover border-brand-aqua/20",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  danger: "bg-red-50 text-red-700 border-red-200",
  info: "bg-blue-50 text-blue-700 border-blue-200",
  purple: "bg-violet-50 text-violet-700 border-violet-200",
};

export function Chip({ variant = "default", className, children, ...rest }) {
  return (
    <span
      className={cn("inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium border", VARIANTS[variant], className)}
      {...rest}
    >
      {children}
    </span>
  );
}

export const stageChip = (stage) => {
  const map = {
    new: "info", contacted: "purple", qualified: "aqua",
    proposal: "warning", won: "success", lost: "danger",
  };
  return map[stage] || "default";
};

export const priorityChip = (p) => ({ high: "danger", medium: "warning", low: "default" }[p] || "default");

export const statusChip = (s) => ({
  open: "info", in_progress: "warning", resolved: "success", closed: "default",
  paid: "success", sent: "info", draft: "default", overdue: "danger", due: "warning",
  todo: "default", done: "success", pending: "warning",
}[s] || "default");
